/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ContextMenuCanvas } from "components/contextMenu/ContextMenuCanvas";
import { contextMenuManager } from "../../contextMenuManager";
import { isContextMenuVisible, shouldEnableContextMenu } from "selectors/contextMenuSelectors";
import { getContextMenuTriggerType } from "../../selectors/contextMenuSelectors";

function mapStoreToProps(stores) {
  return {
    isContextMenuVisible: isContextMenuVisible(stores),
    getContextMenuTriggerType: getContextMenuTriggerType(stores),
    hideContextMenu: eventObj => {
      contextMenuManager.clearMenuItems(stores);
    },
    shouldEnableContextMenu: shouldEnableContextMenu(stores)
  };
}

const ContextMenuCanvasContainer = inject(mapStoreToProps)(ContextMenuCanvas);

export { ContextMenuCanvasContainer };
